import { HpClientStandardInputTextAndStyle } from '../../../types';
import { HpInputControlProps } from '../../../types/inputControlTypes';
import { StandardFormGroupWidget } from '../../widgets/standardFormGroupWidget';

/**
 * Use to add a section error at a particular position.
 * @returns a section error or null.
 */
export function SectionValidationControl({
  answerSource,
  data,
  dataType,
  errors,
  formatType,
  id,
  question
}: HpInputControlProps): JSX.Element | null {
  const error = errors ? errors[id] : undefined;
  if (!error) {
    return null;
  }

  const { textAndStyle: dataTextAndStyle } = data;
  const textAndStyle = dataTextAndStyle[formatType] as HpClientStandardInputTextAndStyle;
  return (
    <StandardFormGroupWidget
      answerSource={answerSource}
      control={<></>}
      controlType="section-validation"
      dataType={dataType}
      error={error}
      helpInfo={undefined}
      helpInfoUI={undefined}
      id={id}
      question={question}
      questionText={undefined}
      subtext={undefined}
      textAndStyle={textAndStyle}
    />
  );
}
